import { apiFetch } from "./api";

export interface JobApprovalDto {
  jobApprovalId: number;
  jobId: number;
  approvalTypeCode: string;
  approvalTypeLabel: string;
  approved: boolean;
  withClient: boolean;
  changeRequested: boolean;
  approvedAtUtc: string | null;
  approvedBy: string | null;
  reworkCount: number;
  requestedAtUtc: string;
  requestedByUserName: string;
  decidedAtUtc: string | null;
  decidedByUserName: string | null;
  decisionComment: string | null;
  rowVersionBase64: string;
}

export interface CrossJobApprovalRowDto {
  jobApprovalId: number;
  jobId: number;
  jobReferenceNo: string;
  clientName: string | null;
  approvalTypeCode: string;
  approvalTypeLabel: string;
  requestedAtUtc: string;
  requestedByUserName: string;
  ageDays: number;
  currentJobStatusCode: string;
}

export interface JobApprovalCommentDto {
  jobApprovalCommentId: number;
  jobApprovalId: number;
  commentText: string;
  authorUserName: string;
  createdAtUtc: string;
}

export const jobApprovalKeys = {
  list: (jobId: number) => ["jobs", jobId, "approvals"] as const,
  comments: (jobId: number, approvalId: number) =>
    ["jobs", jobId, "approvals", approvalId, "comments"] as const,
  cross: (params: Record<string, string | number | undefined>) =>
    ["job-approvals", params] as const,
};

export const jobApprovals = {
  list: (jobId: number) =>
    apiFetch<JobApprovalDto[]>(`/api/jobs/${jobId}/approvals`),
  request: (jobId: number, body: { approvalTypeCode: string; comment?: string }) =>
    apiFetch<{ jobApprovalId: number }>(`/api/jobs/${jobId}/approvals`, { method: "POST", body: JSON.stringify(body) }),
  decide: (jobId: number, approvalId: number,
           body: { decision: "Approve" | "Reject"; comment?: string; rowVersionBase64: string }) =>
    apiFetch<{ jobApprovalId: number; decision: string; advancedToStatusCode: string | null }>(
      `/api/jobs/${jobId}/approvals/${approvalId}/decide`, { method: "POST", body: JSON.stringify(body) }),
  comments: (jobId: number, approvalId: number) =>
    apiFetch<JobApprovalCommentDto[]>(`/api/jobs/${jobId}/approvals/${approvalId}/comments`),
  addComment: (jobId: number, approvalId: number, commentText: string) =>
    apiFetch<{ jobApprovalCommentId: number }>(
      `/api/jobs/${jobId}/approvals/${approvalId}/comments`, { method: "POST", body: JSON.stringify({ commentText }) }),
  cross: (params: { status?: "pending" | "approved" | "rejected"; minAgeDays?: number; approvalTypeCode?: string }) => {
    const qs = new URLSearchParams();
    if (params.status) qs.set("status", params.status);
    if (params.minAgeDays !== undefined) qs.set("minAgeDays", String(params.minAgeDays));
    if (params.approvalTypeCode) qs.set("approvalTypeCode", params.approvalTypeCode);
    const s = qs.toString();
    return apiFetch<CrossJobApprovalRowDto[]>(`/api/job-approvals${s ? `?${s}` : ""}`);
  },
};
